module.exports = __webpack_public_path__ + "static/cloudnative3-4722c59b6123b581a825347493e6badc.jpg";